import { render } from "./VueEditor.vue?vue&type=template&id=1edbced4"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"

import "./VueEditor.vue?vue&type=style&index=0&id=1edbced4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__